























import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import componentLoadingDots from '~/components/loading/dots.vue'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    componentLoadingDots,
  },
})
export default class ComponentFormInputText extends Vue {
  @Prop({ default: null, type: String }) readonly label!: null
  @Prop({ default: 'text', type: String }) readonly type!: string
  @Prop({ default: null, type: String }) readonly description!: null
  @Prop({ default: false, type: Boolean }) readonly loading!: boolean
  @Prop({ default: '-1', type: String }) readonly tabindex!: string
  @Prop({ default: null, type: String }) readonly mask!: string
  @Prop({ default: false, type: Boolean }) readonly error!: boolean
  @Prop({ default: false, type: Boolean }) readonly success!: boolean
  @Prop({ default: '', type: String }) readonly inputmode!: string
  @Prop({ default: false, type: Boolean }) readonly autofocus!: boolean
  @Prop({ default: true, type: Boolean }) readonly autocomplete!: boolean
  @Prop({ default: '', type: String }) readonly value!: string
  @Prop({ default: false, type: Boolean }) readonly disabled!: boolean
  @Prop({ default: false, type: Boolean, required: false })
  readonly setForceBlur!: boolean

  private $style!: IStyle
  private styleAnimation!: IStyle

  private disabledTemp = false

  private focusHandler() {
    this.isFocus = true
  }

  private blurHandler() {
    this.isFocus = false
    this.$emit('blur')
  }

  private async mounted(): Promise<void> {
    if (process.client) {
      const input = this.$refs.input as HTMLInputElement

      if (this.autofocus) {
        if (!this.$device.isIos) {
          input.focus()
        }
      }
      const that = this
      if (that.mask) {
        this.disabledTemp = true
        await import('inputmask').then((module) => {
          module
            .default({
              mask: that.mask,
              showMaskOnHover: false,
            })
            .mask(input)

          this.disabledTemp = false
          setTimeout(() => {
            if (this.autofocus) {
              if (!this.$device.isIos) {
                input.focus()
              }
            }
          })
        })
      }
    }
  }

  private get classWrapper() {
    return {
      [this.$style.inputWrapper]: true,
      [this.$style.error]: this.error && !this.isFocus,
      [this.$style.active]: this.value.trim().length > 0 || this.isFocus,
      [this.styleAnimation.shakeHorizontal]: this.error && !this.isFocus,
      [this.$style.success]: this.success,
      [this.$style.disabled]: this.disabled,
    }
  }

  private get classInput() {
    return {
      [this.$style.input]: true,
      [this.$style.filled]: this.value.trim().length > 0,
      [this.$style.empty]: this.type === 'date' && !this.value,
    }
  }

  private isFocus = false

  @Watch('isFocus')
  private setForceBlurHandler(value: boolean) {
    this.$emit('focus-value-changed', value)
  }

  @Watch('setForceBlur')
  private isFocusHandler(value: boolean) {
    if (value) {
      const input = this.$refs.input as HTMLInputElement
      input.blur()
      this.$emit('force-blur-end')
    }
  }

  private pasteHandler($event: ClipboardEvent) {
    $event.preventDefault()
    const clipboardData = $event.clipboardData
    if (clipboardData) {
      const text = clipboardData.getData('text')
      if (text) {
        this.$emit('input', { target: { value: text } })
      }
    }
  }
}
